export default {
  LOAD_PLAYER(state, player) {
    state.items = player;
  }
};
